import api from './api';

// Servicio para agregar un nuevo survey share
export const addSurveyShare = async (survey_id, person_name) => {
  try {
    const response = await api.post('/survey_shares/add', {
      survey_id,
      person_name
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear el survey share:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para obtener todos los survey shares de una encuesta
export const getAllSurveyShares = async survey_id => {
  try {
    const response = await api.get(`/survey_shares/getAll/${survey_id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los survey shares:',
      error.response?.data || error.message
    );
    return { result: false, shares: [] };
  }
};

// Servicio para obtener un survey share por ID
export const getSurveyShareById = async id => {
  try {
    const response = await api.get(`/survey_shares/getById/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el survey share:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para actualizar un survey share
export const updateSurveyShare = async (id, person_name, is_valid) => {
  try {
    const response = await api.put(`/survey_shares/update/${id}`, {
      person_name,
      is_valid
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar el survey share:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para eliminar un survey share
export const deleteSurveyShare = async id => {
  try {
    const response = await api.delete(`/survey_shares/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al eliminar el survey share:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Nueva función para obtener un share por token (público, no requiere autenticación)
export const getSurveyShareByToken = async token => {
  try {
    const response = await api.get(`/survey_shares/getByToken/${token}`);

    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el survey share por token:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
